import { render, staticRenderFns } from "./BottomText.vue?vue&type=template&id=90db18f8&scoped=true"
import script from "./BottomText.vue?vue&type=script&lang=js"
export * from "./BottomText.vue?vue&type=script&lang=js"
import style0 from "./BottomText.vue?vue&type=style&index=0&id=90db18f8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90db18f8",
  null
  
)

export default component.exports